export function formatScore(scoreBetweenZeroAndOne: number): string {
  const scoreBetweenZeroAndTen = scoreBetweenZeroAndOne * 10;
  return scoreBetweenZeroAndTen.toPrecision(2).replace(".", ",");
}
